<template>
  <div class="pointer">
    <i @click="show = true" class="share-btn fas fa-share-alt"></i>
  </div>
  <teleport to="body">
    <div v-if="show" class="social-container">
      <card-blank>
        <img @click="show = false" class="close-icon pointer" src="@/assets/icons/close.svg">
        <div class="social-header flex justify-content-between">
          <h2>Bagikan Tautan Ini</h2>
        </div>
        <div class="social-apps">
          <img @click="whatsAppShare()" class="icon-app pointer" src="@/assets/icons/whatsapp.svg">
          <img @click="twitterShare()" class="icon-app pointer" src="@/assets/icons/twitter2.svg">
          <img @click="facebookShare()" class="icon-app pointer" src="@/assets/icons/facebook.svg">
        </div>
        <div class="link-share flex">
          <div class="link-url">{{ link }}</div>
          <img class="icon-app pointer" @click="copyUrl()" src="@/assets/icons/copypaste.svg">
        </div>
      </card-blank>
    </div>
  </teleport>
</template>

<script>
import CardBlank from './CardBlank.vue'
export default {
  components: { CardBlank },
  name: 'SocialShareComponent',
  props: {
    link: {
      required: true,
      default: '',
      type: String
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    copyUrl () {
      const valCopy = document.body.appendChild(document.createElement('input'))
      valCopy.value = this.link
      valCopy.select()
      document.execCommand('copy')
      valCopy.parentNode.removeChild(valCopy)

      alert('URL Copied')
    },
    openSmallWindow (url) {
      window.open(url,
        'mywindow', 'menubar=1,resizable=1,width=500,height=400')
    },
    whatsAppShare () {
      const url = `https://api.whatsapp.com/send?text=${this.link}`
      this.openSmallWindow(url)
    },
    twitterShare () {
      const url = `https://twitter.com/intent/tweet?url=${this.link}`
      this.openSmallWindow(url)
    },
    facebookShare () {
      const url = `https://www.facebook.com/sharer.php?u=${this.link}`
      this.openSmallWindow(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .social-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.377);
    // opacity: 0.1;
    z-index: 100;
    width: 100vw;
    height: 100vh;

    .link-share {
      justify-content: center;
      .link-url {
        padding: .2rem;
        border: 1px solid #cecece;
        border-radius: 5px;
        height: 30px;
        word-break: break-all;
        overflow: hidden;
      }
      img {
        margin-left: 10px;
      }
    }

    .social-apps {
      display: flex;
      justify-content: center;
      .icon-app {
        padding: 1rem;
      }
    }
  }
  .share-btn {
      width: 25px;
      height: 25px;
      padding: 5px;
      border-radius: 50%;
      box-shadow: -1px 2px 5px grey;
      display: flex;
      margin-left: 88%;
      justify-content: center;
      align-items: center;
      &:hover {
        background-color: #fff;
      }
  }
  i {
    font-size: 12px;
  }
</style>
